import React from 'react';
import { Trans } from 'react-i18next';
import {
  Users,
  Builders,
  Assets,
  Natives,
  UsersDark,
  BuildersDark,
  AssetsDark,
  NativesDark,
} from 'assets/welcome';

const config = [
  {
    title: <Trans i18nKey="Welcome.connectUsers"></Trans>,
    desc: <Trans i18nKey="Welcome.talk"></Trans>,
    img: Users,
    imgDark: UsersDark,
  },
  {
    title: <Trans i18nKey="Welcome.connectBuilders"></Trans>,
    desc: <Trans i18nKey="Welcome.feedback"></Trans>,
    img: Builders,
    imgDark: BuildersDark,
  },
  {
    title: <Trans i18nKey="Welcome.assets"></Trans>,
    desc: <Trans i18nKey="Welcome.portfolio"></Trans>,
    img: Assets,
    imgDark: AssetsDark,
  },
  {
    title: <Trans i18nKey="Welcome.connectNatives"></Trans>,
    desc: <Trans i18nKey="Welcome.natives"></Trans>,
    img: Natives,
    imgDark: NativesDark,
  },
];

export default config;
